var map = {
	"./icon-del.svg": "NpVA",
	"./icon-excel.svg": "MFBY",
	"./icon-file.svg": "rRHg",
	"./icon-image.svg": "znkQ",
	"./icon-other.svg": "Squw",
	"./icon-pdf.svg": "i1WI",
	"./icon-ppt.svg": "KwLq",
	"./icon-radio.svg": "GzP4",
	"./icon-start.svg": "b533",
	"./icon-suspend.svg": "6lG3",
	"./icon-txls.svg": "0hnM",
	"./icon-txt.svg": "gIfQ",
	"./icon-video.svg": "xDPD",
	"./icon-vsd.svg": "Ljjt",
	"./icon-word.svg": "cqv1",
	"./icon-zip.svg": "nZYe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "x0UA";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctype ^\.\/icon\-.*\.svg$
// module id = x0UA
// module chunks = 25